<template>
  <div id="privacy" class="body-container">
    <div class="body-content" v-show="isShow">

      <div class="sub-title group">SDK名称：</div>
      <div>腾讯Bugly SDK</div>

      <div class="sub-title">使用目的：</div>
      <div>收集崩溃信息，提升App质量，提供异常日志分析服务</div>

      <div class="sub-title">使用场景：</div>
      <div>在程序异常时</div>

      <div class="sub-title">个人信息收集类型：</div>
      <div>设备唯一识别码(IMEI/MEID/AndroidID/IDFA/OPENUDID/IDFV/出厂序列号/SIM卡IMSI)</div>

      <div class="sub-title">收集方式：</div>
      <div>SDK对手机进行本地采集</div>

      <div class="sub-title">第三方公司名称：</div>
      <div>深圳市腾讯计算机系统有限公司</div>

      <div class="sub-title">第三方SDK隐私政策：</div>
      <div><a href="https://privacy.qq.com/document/preview/179ae701076241418eaf276f7595ee54">https://privacy.qq.com/document/preview/179ae701076241418eaf276f7595ee54</a></div>

      <div class="sub-title group">SDK名称：</div>
      <div>华为推送SDK</div>

      <div class="sub-title">使用目的：</div>
      <div>提供消息推送服务</div>
      <div>统计华为推送SDK接口调用成功率。</div>

      <div class="sub-title">使用场景：</div>
      <div>手机在后台时，需要收到会议邀请时进行提醒展示</div>

      <div class="sub-title">个人信息收集类型：</div>
      <div>应用基本信息、应用内设备标识符、设备的硬件信息、系统基本信息和系统设置信息</div>

      <div class="sub-title">收集方式：</div>
      <div>SDK对手机进行本地采集</div>

      <div class="sub-title">第三方公司名称：</div>
      <div>华为软件技术有限公司</div>

      <div class="sub-title">第三方SDK隐私政策：</div>
      <div><a href="https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177">https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177</a></div>

      <div class="sub-title group">SDK名称：</div>
      <div>友盟SDK</div>

      <div class="sub-title">使用目的：</div>
      <div>内容分享，用户行为分析</div>

      <div class="sub-title">使用场景：</div>
      <div>内容分享到第三方软件</div>
      <div>用户使用功能次数记录</div>

      <div class="sub-title">个人信息收集类型：</div>
      <div>设备信息（IMEI/MAC/Android ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/ICCID）、位置信息、网络信息</div>

      <div class="sub-title">收集方式：</div>
      <div>SDK对手机进行本地采集</div>

      <div class="sub-title">第三方公司名称：</div>
      <div>友盟同欣(北京)科技有限公司、北京瑞讯灵通科技有限公司</div>

      <div class="sub-title">第三方SDK隐私政策：</div>
      <div><a href="https://www.umeng.com/page/policy">https://www.umeng.com/page/policy</a></div>

      <div class="sub-title group">SDK名称：</div>
      <div>小米推送SDK</div>

      <div class="sub-title">使用目的：</div>
      <div>为用户提供推送</div>

      <div class="sub-title">使用场景：</div>
      <div>手机在后台时，需要收到会议邀请时进行提醒展示</div>

      <div class="sub-title">个人信息收集类型：</div>
      <div>Mac地址、WiFi SSID、访问电话状态、获取网络信息、设备型号/名称、设备制造商、手机品牌、系统的API级别数字/字符、运行程序列表</div>

      <div class="sub-title">收集方式：</div>
      <div>SDK对手机进行本地采集</div>

      <div class="sub-title">第三方公司名称：</div>
      <div>北京小米科技有限责任公司</div>

      <div class="sub-title">第三方SDK隐私政策：</div>
      <div><a href="https://dev.mi.com/console/doc/detail?pId=1822">https://dev.mi.com/console/doc/detail?pId=1822</a></div>

      <div class="sub-title group">SDK名称：</div>
      <div>VIVO推送SDK</div>

      <div class="sub-title">使用目的：</div>
      <div>向VIVO手机用户推送消息</div>

      <div class="sub-title">个人信息收集类型：</div>
      <div>获取任务信息、获取网络信息、设备制造商、系统的API级别数字/字符、运行程序列表</div>

      <div class="sub-title">使用方式：</div>
      <div>SDK对手机进行本地采集</div>

      <div class="sub-title">第三方公司名称：</div>
      <div>维沃移动通信有限公司</div>

      <div class="sub-title">第三方SDK隐私政策：</div>
      <div><a href="https://dev.vivo.com.cn/documentCenter/doc/652">https://dev.vivo.com.cn/documentCenter/doc/652</a></div>

      <div class="sub-title group">SDK名称：</div>
      <div>OPPO推送SDK</div>

      <div class="sub-title">使用目的：</div>
      <div>向OPPO手机用户推送消息</div>

      <div class="sub-title">个人信息收集类型：</div>
      <div>系统的API级别数字/字符</div>

      <div class="sub-title">使用方式：</div>
      <div>SDK对手机进行本地采集</div>

      <div class="sub-title">第三方公司名称：</div>
      <div>OPPO广东移动通信有限公司</div>

      <div class="sub-title">第三方SDK隐私政策：</div>
      <div><a href="https://open.oppomobile.com/wiki/doc#id=10288">https://open.oppomobile.com/wiki/doc#id=10288</a></div>

      <div class="sub-title group">SDK名称：</div>
      <div>极光推送SDK</div>

      <div class="sub-title">使用目的：</div>
      <div>向OPPO手机用户推送消息</div>

      <div class="sub-title">收集个人信息类型：</div>
      <div>获取任务信息、获取网络信息、设备制造商、系统的API级别数字/字符、运行程序列表</div>

      <div class="sub-title">使用方式：</div>
      <div>SDK对手机进行本地采集</div>

      <div class="sub-title">第三方公司名称：</div>
      <div>深圳市和讯华谷信息技术有限公司</div>

      <div class="sub-title">第三方SDK隐私政策：</div>
      <div><a href="https://www.jiguang.cn/license/privacy">https://www.jiguang.cn/license/privacy</a></div>

      <div class="sub-title group">SDK名称：</div>
      <div>阿里云OSS对象存储SDK</div>

      <div class="sub-title">使用目的：</div>
      <div>上传图片、缓存数据</div>

      <div class="sub-title">收集个人信息类型：</div>
      <div>允许联网、获取网络状态、判断网络状态、获取本地存储</div>

      <div class="sub-title">使用方式：</div>
      <div>SDK对手机进行本地采集</div>

      <div class="sub-title">第三方公司名称：</div>
      <div>北京阿里巴巴云计算技术有限公司</div>

      <div class="sub-title">第三方SDK隐私政策：</div>
      <div><a href="http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=5176.131995.J_9220772140.87.581169fdsILQ3y">http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=5176.131995.J_9220772140.87.581169fdsILQ3y</a></div>

      <div class="sub-title group">SDK名称：</div>
      <div>声网SDK</div>

      <div class="sub-title">使用目的：</div>
      <div>提供视频与音频会议功能</div>

      <div class="sub-title">收集个人信息类型：</div>
      <div>设备类型、设备型号、CPU信息、电池电量信息、操作系统信息</div>
      <div>收发端用户ID、用户属性、频道信息、使用时长、频道内设置名称、日志</div>

      <div class="sub-title">使用方式：</div>
      <div>SDK对手机进行本地采集</div>

      <div class="sub-title">第三方公司名称：</div>
      <div>上海兆言网络科技有限公司</div>

      <div class="sub-title">第三方SDK隐私政策：</div>
      <div><a href="https://www.agora.io/cn/privacy-policy">https://www.agora.io/cn/privacy-policy</a></div>

      <div class="sub-title group">SDK名称：</div>
      <div>魅族PUSH</div>

      <div class="sub-title">使用目的：</div>
      <div>向魅族手机用户消息推送</div>

      <div class="sub-title">收集个人信息类型：</div>
      <div>网卡（MAC）地址、国际移动设备识别码（IMEI）、独立设备标识符、IP地址、设备型号、操作系统版本、电池、信号强度</div>

      <div class="sub-title">第三方公司名称：</div>
      <div>珠海市魅族科技有限公司</div>

      <div class="sub-title">第三方SDK隐私政策：</div>
      <div><a href="https://www.meizu.com/legal.html">https://www.meizu.com/legal.html</a></div>

      <div class="sub-title group">SDK名称：</div>
      <div>MobTech ShareSDK</div>

      <div class="sub-title">使用目的：</div>
      <div>提供社交分享、第三方登录社交分享、第三方登录功能</div>

      <div class="sub-title">使用场景：</div>
      <div>内容分享和第三方登录</div>

      <div class="sub-title">收集个人信息类型：</div>
      <div>系统信息；WIFI状态信息；应用列表信息；基站信息；地理位置</div>

      <div class="sub-title">收集方式：</div>
      <div>SDK对手机进行本地采集</div>

      <div class="sub-title">第三方公司名称：</div>
      <div>上海游昆信息技术有限公司</div>

      <div class="sub-title">第三方SDK隐私政策：</div>
      <div><a href="https://www.mob.com/about/policy">https://www.mob.com/about/policy</a></div>

      <div class="sub-title group">SDK名称：</div>
      <div>支付宝SDK</div>

      <div class="sub-title">使用目的：</div>
      <div>支付</div>

      <div class="sub-title">使用场景：</div>
      <div>购买VIP服务等</div>

      <div class="sub-title">个人信息收集类型：</div>
      <div>设备信息（如IMEI、IMSI、SIM卡序列号、MAC地址、Android ID、SSID、BSSID、设备基础信息【机型\厂商等】）、网络信息。</div>

      <div class="sub-title">收集方式：</div>
      <div>SDK对手机进行本地采集</div>

      <div class="sub-title">第三方公司名称：</div>
      <div>支付宝(中国)网络技术有限公司</div>

      <div class="sub-title">第三方SDK隐私政策：</div>
      <div><a href="https://docs.open.alipay.com/54">https://docs.open.alipay.com/54</a></div>

      <div class="sub-title group">SDK名称：</div>
      <div>微信SDK</div>

      <div class="sub-title">使用目的：</div>
      <div>支付</div>

      <div class="sub-title">使用场景：</div>
      <div>购买VIP服务等</div>

      <div class="sub-title">个人信息收集类型：</div>
      <div>MAC地址、唯一设备识别码</div>

      <div class="sub-title">收集方式：</div>
      <div>SDK对手机进行本地采集</div>

      <div class="sub-title">第三方公司名称：</div>
      <div>深圳市腾讯计算机系统有限公司</div>

      <div class="sub-title">第三方SDK隐私政策：</div>
      <div><a href="https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl">https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl</a></div>


    </div>
  </div>
</template>

<script>
export default {
  name: 'privacy',
  data () {
    return {
      isShow: false
    }
  },
  mounted () {
    setTimeout(() => {
      this.isShow = true
    }, 100)
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
#privacy
  margin .25rem
  font-size 0.14rem
  line-height 0.20rem
  text-align justify
  height auto
  word-break break-all
  h1
    font-weight bold
    font-size 0.16rem
  div
    // text-indent 0.21rem
    margin .01rem 0
    &.title
      text-indent 0
      font-weight bold
      font-size 0.16rem
      margin 0.1rem 0rem
    .sub-title
      font-weight 500
      margin-top 0.08rem
      &.group
        margin-top 0.3rem
    &.sub-p
      text-indent 0.59rem
    a
      color #000
      &:hover
        color #0982cb
</style>



// WEBPACK FOOTER //
// 3dsharelist.vue?42f4115b